exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-module__container___2YPro {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  z-index: 999;\n} ", ""]);
// Exports
exports.locals = {
	"container": "index-module__container___2YPro"
};